import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, r5) {
  var result = Complex.createComplex(r5, 0).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexFFDenominator, c2, r2, r5, rOut, sImaginary) {
  var complexFFNumerator = Complex.createComplex(rOut, sImaginary * c2 * rOut * (r2 + r5));
  var result = complexFFNumerator.divide(complexFFDenominator);
  return result;
}
